
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2a10 10 0 0110 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.8a8.2 8.2 0 100 16.4 8.2 8.2 0 000-16.4zm-.16 10.8a1.438 1.438 0 011.406 1.414A1.412 1.412 0 0110.422 16c.02-.772.646-1.39 1.418-1.4zM9.022 7.95C10.624 6.126 13.4 6.16 14.86 8c.77.956.894 2.686-.528 3.592-.246.156-.498.304-.748.454-.324.194-.61.394-.584.85a.4.4 0 01-.45.418h-1.376c-.36.014-.502-.182-.516-.514a2 2 0 01.982-1.864c.374-.24.772-.444 1.14-.692.608-.4.586-1-.036-1.4a1.6 1.6 0 00-2.136.332c-.722.85-.754.61-1.456.1s-.782-.586-.13-1.326z"}})])
          )
        }
      }
    